import ButtonEmailMacrosDialog from './extensions/src/button-email-macros-dialog.js';


export default function ButtonExtension (extId, pButton)
{
  const pThis = this;

  pThis.getIsExists = getIsExists;

  var extButtonsObjects =
  {
    'EmailMacrosDialog' : ButtonEmailMacrosDialog
  };

  var buttonObject = (extButtonsObjects[extId] && (typeof(extButtonsObjects[extId])) === 'function') ? new extButtonsObjects[extId](pButton) : null;

  if (buttonObject)
  {
    for (let k in buttonObject)
    {
      if (buttonObject.hasOwnProperty(k) && typeof(pThis[k]) === 'undefined')
      {
        pThis[k] = buttonObject[k];
      }
    }
  }


  if (!pThis.getState)
  {
    pThis.getState = function () { return false; }; // TODO:Dime
  }


  function getIsExists ()
  {
    return !!extButtonsObjects[extId];
  }

}